export const SNAPCHAT_PIXEL_ID = "008348d4-ae06-4f4c-854c-b322a613316c";

export const SNAPCHAT_PIXEL_EVENTNAMES = {
	SIGN_UP: "SIGN_UP",
};



// WEBPACK FOOTER //
// ./src/analytics/util/constants.js